import axios from "axios";
const baseDomain = `${process.env.REACT_APP_FIREBASE_BASE_DOMAIN}`;
const baseURL = `${baseDomain}/`;
let axiosObj;
axiosObj = axios.create({
  baseURL,
});
export default axiosObj;
